'use strict';

var React = require('react/addons');
var cx = React.addons.classSet;

var Panel = React.createClass({
  displayName: 'Panel',

  render: function render() {
    var props = this.props;

    var classes = {};
    classes['panel-component'] = true;
    classes[props.className] = true;

    return React.createElement(
      'div',
      { className: cx(classes) },
      React.createElement(
        'div',
        { className: 'title' },
        props.title
      ),
      React.createElement(
        'div',
        { className: 'content' },
        props.children
      )
    );
  }
});

module.exports = Panel;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/ui/panel.js
 **/